import { ChangeItem } from '@app/features/scope-overview/change-request/model'
import { ScopeElementsConfig } from '../../models/scope-elements-config.interface'
import { ValueDiff } from '../../models/entities-with-changes/value-diff.interface'
import { isNil } from 'lodash'
import { EntityWithChanges } from '../../models/entities-with-changes/entity-with-changes.type'
import { Role } from '@app/features/scoping/models/role.model'

export function showCrDifferences<T>(config: ScopeElementsConfig, element: EntityWithChanges<T>, fieldName: string) {
  return config?.isChangeRequest && config?.showDiff && isDifferent(element?.changes?.[fieldName])
}

const isDifferent = (value: ValueDiff): boolean => !isNil(value) && value?.new !== value?.old

export function showCrNetDelta(config: ScopeElementsConfig, changeItem: ChangeItem, fieldName: string): boolean {
  const diff = changeItem?.data?.[fieldName]
  return config?.isChangeRequest && config?.showNetDelta && !isNil(diff) && diff.new !== diff.old
}

export function getCrFieldDelta(changeItem: ChangeItem, fieldName: string): number {
  const diff = changeItem?.data?.[fieldName]
  return (diff?.new ?? 0) - (diff?.old ?? 0)
}

export function getNumberDeltaValue(current: number | null | undefined, old: number | null | undefined): number {
  return (current ?? 0) - (old ?? 0)
}

export function getDeltaValue(
  entity: any,
  currentKey: string,
  fallback: number | null | undefined,
  oldKey: string
): number {
  return getNumberDeltaValue(entity[currentKey] ?? fallback, entity[oldKey])
}

export function showPricingDeltaForConfig(config: ScopeElementsConfig): boolean {
  return !!(config?.isChangeRequest && config?.showNetDelta)
}

export function getRoleOldSellingRate(role: Role, costPlusValue: number): number {
  const oldCost = role['oldRateCardCost']?.amount ?? role['oldRateCardCost']?.getValue?.() ?? 0
  if (oldCost) {
    return oldCost + (oldCost * (costPlusValue || 0)) / 100
  }
  return role['oldRateCardRate']?.amount ?? role['oldRateCardRate']?.getValue?.() ?? 0
}
